  <!-- Breadcrumb -->
  <div class="content-breadcrumb div-breadcrumb">
    <em class="fa fa-info-circle icon-breadcrumb"></em>
    <span class="text-breadcrumb">Informações Guia Médica</span>
  </div>
  <div class="container-fluid">
    <app-card titleCard="Assistência Médica Moura - Detalhes">
      <ul class="list-group list-group-flush">
        <!-- BLOCO DE INFORMAÇÕES DO BENEFICIÁRIO -->
        <li class="list-group-item">
          <div class="row">
            <div class="col-12 mb-2 text-info-guia">
              <strong class="text-info">Código Guia: &nbsp;&nbsp;</strong> {{ guiaMedica.id }}
            </div>
            <div class="col-12 col-sm-12 col-md-8 col-lg-10 mb-2 text-info-guia">
              <strong class="text-info mr-2">Funcionário: &nbsp;</strong> {{ guiaMedica.nomeTitular }}
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-lg-2 mb-2 text-info-guia">
              <strong class="text-info">CPF:&nbsp;</strong>{{ guiaMedica.cpfTitular | cpf }}
            </div>
            <div class="col-12 col-sm-12 col-md-8 col-lg-10 mb-2 text-info-guia">
              <strong class="text-info mr-2">Beneficiário: &nbsp;</strong> {{ guiaMedica.beneficiado }}
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-lg-2 mb-2 text-info-guia">
              <strong class="text-info">Matricula:&nbsp;</strong>{{ guiaMedica.estabelecimentoCodigo + guiaMedica.matricula }}
            </div>
            <div class="col-12 mb-2 text-info-guia">
              <strong class="text-info">Atendimento: &nbsp;</strong> {{ guiaMedica.dataAtendimento | date:'dd/MM/yyyy HH:mm:ss' }}
            </div>
            <div *ngIf="guiaMedica.encaminhado" class="col-12 mt-2 mb-2 text-encaminhamento">
              <strong> * Guia médica encaminhada pelo ambulatório Moura </strong>
            </div>
          </div>
        </li>

        <!-- BLOCO DE INFORMAÇÕES DO PRESTADOR -->
        <li class="list-group-item">
          <div class="row mt-2">
            <div class="col-12 col-sm-12 col-md-8 col-lg-10 mb-2 text-info-guia">
              <strong class="text-info mr-1">Prestador: &nbsp;</strong> {{ guiaMedica.usuario?.prestador?.nome }}
            </div>
            <div class="col-12 col-sm-12 col-md-4 col-lg-2 mb-2 text-info-guia">
              <strong class="text-info">CNPJ/CPF:&nbsp;</strong>{{ guiaMedica.usuario?.prestador?.documento }}
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-2 text-info-guia">
              <strong class="text-info">Atendente: &nbsp;</strong> {{ guiaMedica.usuario?.nome }}
            </div>
          </div>
        </li>

        <!-- BLOCO DE INFORMAÇÕES DOS PROCEDIMENTOS REALIZADOS -->
        <li class="list-group-item">
          <div class="row mt-2">
            <div class="col-12">
              <div class="mb-2 text-info-guia" >
                <strong class="text-info"><i class="fa fa-list"></i> Procedimentos Realizados:</strong><br>
              </div>
              <div class="table-responsive mt-3">
                <table class="table table-bordered table-hover text-center text-table">
                    <thead>
                        <tr class="table-active">
                            <th>Procedimento</th>
                            <th style="width: 70px">Quantidade</th>
                            <th style="width: 120px">Valor Unitário</th>
                            <th style="width: 120px">Valor Total</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let atendimento of guiaMedica.atendimentos">
                          <td>{{ atendimento.procedimento.nome }}</td>
                          <td>{{ atendimento.quantidade }}</td>
                          <td>R$ {{ atendimento.valorUnitario | number:'1.2-2' }}</td>
                          <td>R$ {{ atendimento.quantidade * atendimento.valorUnitario | number:'1.2-2' }}</td>
                      </tr>
                      <tr>
                        <th colspan="4">
                          <p class="text-end m-1 p-0 font-italic">
                            Subtotal: R$ {{ subTotalProcedimentos | number:'1.2-2' }}
                          </p>
                        </th>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- BLOCO DE OUTROS TIPO DE PROCEDIMENTOS -->
          <div class="row mt-2" *ngIf="guiaMedica.atendimentosEstratificados?.length !== 0">
            <div class="col-12">
              <div class="mb-2 text-info-guia">
                <!-- Lista de outros tipos de serviço: Medicamento, material, diária e taxas. -->
                <strong class="text-info"><i class="fa fa-list"></i> Lista de outros tipos de serviço: Medicamento, material, diária e taxas. </strong><br>
              </div>
              <div class="table-responsive mt-3">
                <table class="table table-bordered table-hover text-center text-table">
                    <thead>
                        <tr class="table-active">
                            <th>Nome</th>
                            <th style="width: 70px">Tipo</th>
                            <th style="width: 120px">Valor</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let atendimento of guiaMedica.atendimentosEstratificados">
                          <td>{{ atendimento.nome }}</td>
                          <td>{{ atendimento.tipo }}</td>
                          <td>R$ {{ atendimento.valor | number:'1.2-2' }}</td>
                      </tr>
                      <tr>
                        <th colspan="4">
                          <p class="text-end m-1 p-0 font-italic">
                            Subtotal: R$ {{ subTotalOutrosProcedimentos | number:'1.2-2' }}
                          </p>
                        </th>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- BLOCO EXIBIÇÃO VALOR TOTAL DA GUIA -->
          <div class="row mt-2">
            <div class="col-12">
              <p class="text-end">
                <strong class="texto-valor-total mt-2">Valor Total Atendimento: R$ {{ guiaMedica.valorTotal | number:'1.2-2' }}</strong>
              </p>
            </div>
          </div>
        </li>
        <li class="list-group-item">
          <div class="row mt-3">
            <div class="col text-encaminhamento">
              <strong class="text-data mt-0">Última alteração: &nbsp; {{ guiaMedica.dataAtualizacao | date:'dd/MM/yyyy HH:mm:ss' }}</strong>
            </div>
            <div class="col-auto">
              <button type="button" class="btn btn-outline-info ms-2 float-right" (click)="modalPreExibicaoPDF(content)">
                <i class="fa fa-print" aria-hidden="true"></i>&nbsp; Imprimir
              </button>
              <button type="button" class="btn btn-outline-secondary ms-2 float-right" routerLink="/atendimentos">
                <i class="fa fa-chevron-left"></i>&nbsp; Voltar
              </button>
              <button *ngIf="!exibirBotoes(guiaMedica.finalizado)" type="submit" class="btn btn-outline-success ms-2 float-right" [routerLink]="['/atendimentos/edit', guiaMedica.id]">
                <i class="fa fa-check" aria-hidden="true"></i>&nbsp; Editar Guia
              </button>
            </div>
          </div>
        </li>
      </ul>
    </app-card>
  </div>

 <!-- MODAL PARA IMPRIMIR A GUIA MÉDICA -->
  <ng-template #content let-closed="close" let-dismiss="dismiss">
    <div class="modal-personalizado-header mb-4">
      <h5 class="modal-personalizado-header-title">Pré-visualização do PDF</h5>
      <button type="button" class="btn btn-primary mr-2 btn-fechar" (click)="dismiss('click')">
        <span aria-hidden="true">&times;</span>
     </button>
    </div>

    <!-- TEMPLATE DO PDF -->
    <app-exportar-pdf [guiaMedica]="guiaMedica" [subTotalProcedimentos]="subTotalProcedimentos"
      [subTotalOutrosProcedimentos]="subTotalOutrosProcedimentos" ngbAutofocus></app-exportar-pdf>

    <!-- FOOTER DO MODAL DA PRÉ-VISUALIZAÇÃO -->
    <div class="modal-footer mt-5">
      <button type="button" class="btn btn-secondary" (click)="dismiss('click')">
        <i class="fa fa-times" aria-hidden="true"></i>&nbsp; Fechar Exibição
      </button>
  </div>
  </ng-template>
